<div class="igntr-theme max-w-[1280px] mx-auto bg-[--background-color]">
  <div class="p-7 space-y-5">
    <div class="flex items-start justify-between mb-4 flex-wrap gap-2">
      <div class="flex items-start gap-2.5">
        <div
          class="w-8 h-8 rounded-lg bg-white border !border-slate-200 flex items-center justify-center !text-slate-700"
        >
          <igntr-icon name="check"></igntr-icon>
        </div>
        <div>
          <div class="text-[14px] font-semibold !text-slate-900">
            {{ "checklists" | transloco }}
          </div>
          <div class="text-[12px] !text-slate-500 mt-0.5">
            {{ data.length }} {{ "checklistsInThisTenant" | transloco }}
          </div>
        </div>
      </div>
      <div class="flex items-center gap-3 justify-end">
        <button
          class="px-2.5 py-1.5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium inline-flex items-center gap-1.5"
          (click)="exportToExcel()"
        >
          <igntr-icon name="upload"></igntr-icon>
          {{ "export" | transloco }}
        </button>
        <button
          class="px-2.5 py-1.5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium inline-flex items-center gap-1.5"
          (click)="showModalWindow()"
        >
          <igntr-icon name="plus"></igntr-icon>
          {{ "newChecklist" | transloco }}
        </button>
      </div>
    </div>
    <div
      class="rounded-xl border !border-slate-200/70 bg-white divide-y divide-slate-100"
      *ngIf="data.length > 0"
    >
      <div
        class="flex items-center gap-3 px-3.5 py-3"
        *ngFor="let checklist of data"
      >
        <div
          class="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center"
        >
          <igntr-icon name="check"></igntr-icon>
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-[14px] font-semibold !text-slate-900">
            {{ checklist.title }}
          </div>
          <div class="text-[14px] !text-slate-500">
            {{ "allHires" | transloco }} · {{ checklist.items?.length }} items
          </div>
        </div>
        <span
          class="text-[14px] px-1.5 py-0.5 rounded bg-emerald-50 text-emerald-700"
        >
          {{ "active" | transloco }}
        </span>
        <button
          [matMenuTriggerFor]="menu"
          class="!text-slate-400 hover:!text-slate-700 p-1.5 rounded hover:!bg-slate-100"
        >
          <igntr-icon name="dots"></igntr-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            class="text-danger"
            (click)="deleteConf = { id: checklist.id!, name: checklist.title }"
            title="{{ 'delete' | transloco }}"
          >
            {{ "delete" | transloco }}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
<!-- <div
  class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-3 mb-3"
>
  <h2 class="page-title mt-4 mb-2 mb-sm-0" i18n="Label users">
    {{ "standard" | transloco }} {{ "checklists" | transloco }}
  </h2>
  <div class="d-flex gap-2">
    <button
      class="edit-button btn btn-orange d-flex align-items-center"
      (click)="exportToExcel()"
    >
      <img
        src="assets/icons/upload.svg"
        style="height: 20px"
        alt="export icon"
      />
      <span class="ms-2">{{ "export" | transloco }}</span>
    </button>
    <button
      class="edit-button btn btn-orange d-flex align-items-center"
      (click)="showModalWindow()"
    >
      <i class="pi pi-plus"></i>
      <span class="ms-2">{{ "add" | transloco }}</span>
    </button>
  </div>
</div>
<div class="mb-3" style="max-width: 400px">
  <p-inputgroup>
    <p-inputgroup-addon>
      <i class="pi pi-search"></i>
    </p-inputgroup-addon>
    <input
      type="text"
      pInputText
      placeholder="{{ 'search' | transloco }}"
      [(ngModel)]="filterSearchText"
      (input)="applyFilters()"
    />
  </p-inputgroup>
</div> -->
<!-- 
<p-table
  #dt1
  [value]="filteredData"
  [globalFilterFields]="[
    'title',
    'countOfActive',
    'countOfCompleted',
    'createdAt',
  ]"
  class="w-100"
  [responsiveLayout]="'scroll'"
>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="title" style="min-width: 120px">
        {{ "title" | transloco }}
      </th>
      <th
        pSortableColumn="createdAt"
        class="d-none d-sm-table-cell"
        style="min-width: 140px"
      >
        {{ "createdAt" | transloco }}
      </th>
      <th pSortableColumn="countOfUsers" style="min-width: 80px">
        {{ "active" | transloco }}
      </th>
      <th pSortableColumn="countOfCompleted" style="min-width: 80px">
        {{ "completed" | transloco }}
      </th>
      <th style="min-width: 40px"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-data>
    <tr>
      <td class="truncate-text">
        {{ data.title }}
        <div class="d-block d-sm-none text-muted small mt-1">
          <ng-container *ngIf="data.createdAt">
            <i class="pi pi-calendar me-1"></i>
            {{ data.createdAt | date: "dd-MM-yyyy" }}
          </ng-container>
        </div>
      </td>
      <td class="d-none d-sm-table-cell">
        <ng-container *ngIf="data.createdAt">
          {{ data.createdAt | date: "dd-MM-yyyy HH:mm" }}
        </ng-container>
      </td>
      <td>
        {{ data.countOfActive }}
      </td>
      <td>
        {{ data.countOfCompleted }}
      </td>
      <td class="text-end">
        <button
          mat-icon-button
          class="text-danger"
          (click)="deleteConf = { id: data.id!, name: data.title }"
          aria-label="Delete"
        >
          <i class="pi pi-trash"></i>
        </button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <p class="text-muted px-3 py-2">{{ "noItemsFound" | transloco }}</p>
  </ng-template>
</p-table> -->

<p-dialog
  [(visible)]="showDialog"
  [modal]="true"
  [closable]="true"
  [style]="{
    width: '70vw',
    maxWidth: '600px',
    maxHeight: '600px',
  }"
  header="{{ 'add' | transloco }} {{ 'checklist' | transloco }}"
>
  <app-checklist-modal
    [tenantId]="id!"
    [loading]="loading"
    [isOpen]="showDialog"
    (checklistCreated)="closeModal()"
  >
  </app-checklist-modal>
</p-dialog>

<app-confirm-delete
  id="deleteusermodal"
  *ngIf="deleteConf"
  [deleteCandidate]="deleteConf.name"
  (confirm)="handleDeleteClick(deleteConf.id); deleteConf = null"
  (cancel)="deleteConf = null"
></app-confirm-delete>
